/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2023-02-21 15:54:46
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-09-14 00:53:40
 * @FilePath: \baishu_react_ui\src\components\BsyLinkData\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import React from "react";

import { BsyWidget } from "../BsyWidget";
import "./index.css";
import BsySlidePane from "../BsySlidePane";
import { BsyUtils } from "../../utils/Utils";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyIconBtn from "../BsyIconBtn";
import { ShowDataPane } from "./showDataPane";
import BsyDialog from "../BsyDialog";
import { ShowTreePane } from "./showTreePane";
import BsySearchInput from "../BsySearchInput";
import { dayjsUtils } from "../../utils/dayjsUtils";

export default class BsyFormLoadData extends BsyWidget {
  constructor(props) {
    super({
      baseCls: "bsy-data-load-pane",
      onSelectAfter: null,
      loaddataconfig: null,
      entryId: "",
      components: {},
      hasUserSource: !1,
      sizeUnit: 15,
      cols: 60,
      gap: 10,
      padding: [2, 10],
      hasLazyLoad: !1,
      supportExport: !0,
      relative: !1,
      scrollView: null,
      mode: "dataload",
      isSubform: !0,
      subform: "",
      text: React.language("data.loading"),
      ...props,
    });
    this.initFields(props.loaddataconfig);
  }

  initFields = (loaddataconfig) => {
    if (loaddataconfig) {
      const findField = (field, fields) => {
        return fields.filter((it) => it.name === field || it.tag === field);
      };

      var tagBase = new Date().getTime();
      const dataOnlyFields = (loaddataconfig.mapFields || [])
        .map((it) => {
          if (it.mode !== "depend") {
            return null;
          }

          if (it.depend.field.indexOf("f_") > -1) {
            return null;
          }

          let d = findField(it.depend.field, loaddataconfig.fields || []);
          if (d && d.length) {
            return null;
          }

          return {
            form: loaddataconfig.forms,
            dataOnly: true,
            name: it.depend.field,
            tag: "f_" + tagBase++,
            text: it.depend.field,
            title: it.depend.field,
            subform: it.subform,
            type: it.type,
          };
        })
        .filter((it) => it);
      this.fields = (loaddataconfig.fields || [])
        .map((it) => it)
        .concat(dataOnlyFields);
      if (!BsyUtils.isObjectEmpty(loaddataconfig.treeFields)) {
        this.fields.push({
          ...loaddataconfig.treeFields.treeTitle,
          dataOnly: true,
        });
      }
    }
  };

  getValue = () => {
    return null;
  };

  componentDidMount() {
    super.componentDidMount();
  }

  _constructOpt = () => {
    var opt = this.options;
    var that = this;
    var loaddataconfig = opt.loaddataconfig;
    if (BsyUtils.isObjectEmpty(loaddataconfig)) {
      tipAlert({
        type: "warning",
        msg: "请先设置数据加载的配置信息",
      });
      return;
    }
    var selectIndex = 0;
    var selectWidth = 15;
    var selectHeigh = 6;

    let formdata = this.props.onGetFormData();

    BsyUtils.forEach(loaddataconfig.selectFields, function (a1, b1) {
      b1.widgetId = b1.fields[0].field
        ? b1.fields[0].field
        : [b1.fields[0].subform, b1.fields[0].subField].join(".");
      b1.height = 6;
      b1.width = 15;
      b1.mode = "edit";
      b1.triggers = ["datatableDataLoad" + opt.widgetName];
      b1.posX = (selectIndex % 4) * selectWidth;
      b1.posY = parseInt(selectIndex / 4) * selectHeigh;
      opt.components[b1.widgetId] = b1;
      selectIndex++;
    });

    that.widgetFilter = JSON.parse(JSON.stringify(loaddataconfig.filter));

    if (!BsyUtils.isObjectEmpty(that.widgetFilter.cond)) {
      BsyUtils.forEach(that.widgetFilter.cond, function (a1, b1) {
        if (b1.fieldvalueMode == "widget") {
          var values = [];
          BsyUtils.forEach(b1.value, function (a2, b2) {
            if (!BsyUtils.isEmpty(formdata[b2])) {
              switch (b1.type) {
                case "checkboxgroup":
                case "combocheck":
                case "usergroup":
                case "deptgroup": {
                  if (!BsyUtils.isObjectEmpty(formdata[b2])) {
                    values = values.concat(formdata[b2]);
                  }
                  break;
                }
                case "address": {
                  if (!BsyUtils.isObjectEmpty(formdata[b2])) {
                    let a = formdata[b2];
                    if (a.province) {
                      values.push(a.province ? a.province : null);
                    }
                    if (a.city) {
                      values.push(a.city ? a.city : null);
                    }
                    if (a.district) {
                      values.push(a.district ? a.district : null);
                    }
                  }
                  break;
                }
                case "linkdata": {
                  if (!BsyUtils.isObjectEmpty(formdata[b2])) {
                    if (formdata[b2].key) values.push(formdata[b2].key);
                  }
                  break;
                }
                case "datetime": {
                  if (formdata[b2])
                    values.push(
                      BsyUtils.date2Str(
                        dayjsUtils.timeToTZ(formdata[b2]),
                        b1.format || "yyyy-MM-dd"
                      )
                    );
                  break;
                }
                default: {
                  values.push(formdata[b2]);
                  break;
                }
              }
            }
          });
          if (BsyUtils.isObjectEmpty(values)) {
            b1.method = "empty";
          }
          b1.value = values;
        }
      });
    }

    var datatable = {
      widgetId: "datatableDataLoad" + opt.widgetName,
      widgetNameAlias: "datatableDataLoad" + opt.widgetName,
      appId: opt.appId,
      entryId: opt.formId || opt.entryId,
      width: 60,
      height: 40,
      posY: Math.ceil(selectIndex / 4) * selectHeigh,
      posX: 0,
      hasCount: false,
      chart_label: { enable: true },
      url: "/data/formdataload",
      //特殊情况，需要使用，设计界面的接口

      onDataGet: (url, config, cb) => {
        let newConfig = {
          widgetAssistId: "datatableDataLoad" + opt.widgetName,
          widget: {
            fields: config.fields,
            forms: [loaddataconfig.forms],
            hasHeader: true,
            posX: 0,
            posY: 6,
            height: 40,
            width: 60,
            type: "data_table",
            formulas: [],
          },
          limit: config.limit,
          skip: config.skip,
          appId: opt.appId,
          entryId: opt.formId || opt.entryId,
          sort: !BsyUtils.isObjectEmpty(config.sort)
            ? config.sort
            : loaddataconfig.defaultSort,
          rowOrder: {},
          top: {},
          hasCount: true,
          // "isCountOnly": true,
          popupFormPath: [],
          designAppId: opt.designAppId,
          designEntryId: opt.designEntryId,
          designWidget: opt.widget,
        };
        newConfig.filter = config.filter;
        newConfig.widget.filter = that.widgetFilter;

        React.axios(`/data/formdataload`, newConfig).then((res) => {
          BsyUtils.showAjaxTip(res.data, () => {
            cb && cb({ ...res });
          });
        });
      },
      selectSingleData: (data) => {
        // console.log('BsyFormLoadData ', data);
        this.props.onSelectData &&
          this.props.onSelectData(this.convertData(data));
        if (this.showPopRef) {
          this.showPopRef.closeAlter();
          this.showPopRef = null;
        }
      },
      designWidget: opt.widget,
      designAppId: opt.appId,
      designEntryId: opt.formId || opt.entryId,
      fields: loaddataconfig.fields,
      // filter: filter,
      defaultSort: loaddataconfig.defaultSort,
      forms: [loaddataconfig.forms],
      formulas: [],
      hasExport: false,
      itemsPerPage: 20, //默认单页20条，200行，如果字段行过多，会卡死
      multipleChoice: true, //开启默认多选
      checkStatus: opt.isSubform ? "check" : "radio",
      metrics: [],
      origin: "dash",
      palette: "preset_1",
      permission: "all",
      type: "data_table",
    };
    opt.components["datatableDataLoad" + opt.widgetName] = datatable;
    window.FX.Utils._filterDefaultReplace(
      opt,
      { arg: loaddataconfig.selectArg },
      formdata
    );
  };

  convertData = (data) => {
    let newData = { ...data };
    this.fields.map((field) => {
      if (newData[field.tag]) {
        newData[field.name] = data[field.tag];
      }
    });
    return newData;
  };

  onSelectData = (type) => {
    let dataTmp = this.pupupDashContext.getValue();

    const data = dataTmp.map((item) => {
      return this.convertData(item);
    });

    let newData = [];
    let subfields = {};
    let mapFields = this.options.loaddataconfig.mapFields;
    BsyUtils.forEach(mapFields, (k, val) => {
      if (val.depend && val.depend.field.indexOf(".") > -1) {
        let vd = val.depend.field.split(".");
        if (!subfields[vd[0]]) {
          subfields[vd[0]] = [];
        }
        if (subfields[vd[0]].indexOf(vd[1]) == -1) {
          subfields[vd[0]].push(vd[1]);
        }
      }
    });
    let hasSubform = BsyUtils.isObjectEmpty();
    BsyUtils.forEach(data, (k, row) => {
      if (!hasSubform) {
        newData.push(row);
      } else {
        //判断一下，子表单最大行是多少
        let maxline = 0;
        BsyUtils.forEach(subfields, (sk) => {
          if (row[sk] && row[sk].length) {
            maxline = row[sk].length > maxline ? row[sk].length : maxline;
          }
        });
        if (maxline == 0) {
          newData.push(row);
        } else {
          //解析 子表单数据成多行
          let rows = [];
          for (let index = 0; index < maxline; index++) {
            let rowdata = JSON.parse(JSON.stringify(row));
            BsyUtils.forEach(subfields, (sk, sv) => {
              let d = rowdata[sk];
              if (d && d.length > index) {
                BsyUtils.forEach(sv, (svk, svv) => {
                  let name = [sk, svv].join(".");
                  rowdata[name] = d[index][svv];
                });
              }
            });
            rows.push(rowdata);
          }
          newData = newData.concat(rows);
        }
      }
    });

    this.props.onSelectData && this.props.onSelectData(newData, type);

    // console.log(data);
  };

  onResetRel = (t) => {
    if (this.pupupDashContext && this.pupupDashContext.setRel)
      this.pupupDashContext.setRel(t);
  };

  onResetFilter = () => {
    this.pupupDashContext.ResetFilter();
  };

  dfi = () => {
    let that = this;

    BsyUtils.forEach(that.options.components, function (t, i) {
      if (!i || !i.widgetId) {
        return true;
      }
      if (i.type.indexOf("filter") > -1) {
        let context = that.pupupDashContext.widgetsMap[i.widgetId];
        if (context) {
          context.doFilterRely(null, null, that.widgetFilter);
        }
      }
    });
  };

  onSearchText = (search) => {
    if (search.keywords.length) {
      this.pupupDashContext.reload({
        search: search,
      });
    } else {
      this.pupupDashContext.reload({ search: null });
    }
  };
  onShowPane = () => {
    let that = this;

    var loaddataconfig = that.options.loaddataconfig;
    if (!BsyUtils._checkLoadDataConfig(loaddataconfig)) {
      return;
    }

    this._constructOpt();

    const { text, appId, formId, entryId, isSubform, widget, subform } =
      this.options;
    window.FX.STATIC.ENTRYID = formId;
    let rel = loaddataconfig.selectRel || "and";

    if (loaddataconfig.mode === "tree") {
      BsyDialog({
        title: React.language("widget.linkdata.select"),
        isMove: true,
        moveKey: ["formdataBsyDialog"].join(""),
        height: 600,
        width: 800,
        hasFullScreen: true,
        noFooter: true,
        onHeaderCreate: (ref) => {
          return (
            <div
              onMouseDown={(e) => {
                e.stopPropagation();
              }}
            >
              <BsySearchInput
                placeholder={React.language("search.data")}
                styleInput={{
                  width: "200px",
                }}
                style={{
                  position: "absolute",
                  top: 16,
                  right: 110,
                }}
                onSearch={(val) => {
                  this.onSearchText({
                    fields: [loaddataconfig.treeFields.treeTitle.name],
                    isSearchAllFields: false,
                    keywords: val ? [val] : [],
                  });
                }}
                type={window.mode}
                // iconName="icon-bsy-reportmenu-0"
              ></BsySearchInput>
            </div>
          );
        },
        onContentCreate: (ref) => {
          this.showPopRef = ref;
          return (
            <ShowTreePane
              getContext={(ref) => {
                this.pupupDashContext = ref;
              }}
              appId={appId}
              entryId={formId || entryId}
              forms={loaddataconfig.forms}
              filter={that.widgetFilter}
              fields={this.fields}
              selectFields={loaddataconfig.selectFields}
              selectRel={loaddataconfig.selectRel}
              treeFields={loaddataconfig.treeFields}
              mapFields={loaddataconfig.mapFields}
              defaultSort={loaddataconfig.defaultSort}
              dataloadmode={loaddataconfig.dataloadmode}
              designAppId={appId}
              isSubform={isSubform}
              subform={subform}
              designEntryId={entryId}
              designWidget={widget}
              onMultiSelect={(val) => {
                this.onSelectData(val);
                if (this.showPopRef) {
                  this.showPopRef.closeAlter();
                  this.showPopRef = null;
                }
              }}
              onSelectData={(data, type) => {
                this.props.onSelectData &&
                  this.props.onSelectData(this.convertData(data));
                if (this.showPopRef) {
                  this.showPopRef.closeAlter();
                  this.showPopRef = null;
                }
              }}
            />
          );
        },
      });

      return;
    }

    BsySlidePane({
      title: text,
      hasFooter: isSubform ? true : false,
      onHeaderMenu: () => {
        return (
          <div className="slide-dash-menu">
            {
              <div
                className="dash-filter-rel"
                data-tip={
                  rel === "and"
                    ? React.language("reset.filter.and.tip")
                    : React.language("reset.filter.or.tip")
                }
                data-place={"bottom"}
                data-type={window.mode}
                data-html={true}
              ></div>
            }
          </div>
        );
      },
      onFooter: () => {
        let dataloadmode = this.options.loaddataconfig.dataloadmode;
        return (
          <div className="menu">
            {dataloadmode.indexOf("cover") > -1 ? (
              <BsyIconBtn
                text={React.language("cover.data")}
                click={() => {
                  this.onSelectData("cover");
                  if (this.showPopRef) {
                    this.showPopRef.closeAlter();
                    this.showPopRef = null;
                  }
                }}
                type={"blue"}
                mode={window.mode}
              ></BsyIconBtn>
            ) : (
              ""
            )}
            {dataloadmode.indexOf("add") > -1 ? (
              <BsyIconBtn
                text={React.language("add.data")}
                click={() => {
                  this.onSelectData("add");
                  if (this.showPopRef) {
                    this.showPopRef.closeAlter();
                    this.showPopRef = null;
                  }
                }}
                type={"blue"}
                mode={window.mode}
              ></BsyIconBtn>
            ) : (
              ""
            )}
          </div>
        );
      },
      onContentCreate: (ref) => {
        this.showPopRef = ref;

        return (
          <ShowDataPane
            getContext={(ref) => {
              this.pupupDashContext = ref;
            }}
            appId={appId}
            entryId={formId || entryId}
            forms={loaddataconfig.forms}
            fields={this.fields}
            filter={that.widgetFilter}
            selectFields={loaddataconfig.selectFields}
            selectRel={loaddataconfig.selectRel}
            defaultSort={loaddataconfig.defaultSort}
            designAppId={appId}
            isSubform={isSubform}
            designEntryId={formId || entryId}
            designWidget={widget}
            onSelectData={(data) => {
              this.props.onSelectData &&
                this.props.onSelectData(this.convertData(data));
              if (this.showPopRef) {
                this.showPopRef.closeAlter();
                this.showPopRef = null;
              }
            }}
          />
        );
      },
    });
  };

  render() {
    const { cssName, css, text } = this.options;

    return (
      <div className={cssName} style={css} ref={this.element}>
        <div className="link-btn" onClick={this.onShowPane}>
          <i className={"icon-widget-dataload"}></i>
          <span>{text}</span>
        </div>
      </div>
    );
  }
}
